export const isValidVin = (value: string) => /^[A-HJ-NPR-Z0-9]{17}$/i.test(value);

export const isValidPlate = (value: string) =>
    /^[АВЕКМНОРСТУХABEKMHOPCTYX]{1}\d{3}[АВЕКМНОРСТУХABEKMHOPCTYX]{2}\d{2,3}$/i.test(
        value.replace(/\s+/g, "")
    );

export const normalizeVinOrPlate = (value: string) => value.trim().toUpperCase();

export const isValidVinOrPlate = (value: string) => {
    const normalized = normalizeVinOrPlate(value);
    return isValidVin(normalized) || isValidPlate(normalized);
};